import { Manager } from 'socket.io-client';
import { token, useInjection } from '../../di';

export const WEBSOCKET_MANAGER = token<Manager>('WEBSOCKET_MANAGER');

export const useSocketManager = () => useInjection(WEBSOCKET_MANAGER);
